class Burger {
	constructor($el) {
		this.$el = $el;
		this.$body = $('body');
		this.$html = $('html');
		this.$header = $('header');
		this.$navigation = $('.navigation__container');
		this.$close = $('.navigation__close');
		this.$overlay = $('.navigation__overlay');
		this.$links = $('.navigation__link');

		this.init();
	}

	init = () => {
		this.$el.on('click', this.toggle);
		this.$close.on('click', this.close);
		this.$overlay.on('click', this.close);
		this.$links.on('click', this.close);
		$(document).on('keydown', this.keydownHandler);
		$(window).on('resize', this.resizeHandler);

		this.updateAriaState();
	};

	toggle = () => {
		if (this.$body.hasClass('nav--open')) {
			this.close();
			return;
		}

		this.open();
	};

	open = () => {
		this.$body.addClass('nav--open');
		this.$html.addClass('no-scroll');
		this.$header.removeClass('header--hidden');

		this.$el.attr({
			'aria-expanded': 'true',
			'aria-label': 'Navigation schliessen',
		});

		this.$navigation.attr('aria-hidden', 'false');
		this.$overlay.attr('aria-hidden', 'false');
	};

	close = () => {
		this.$body.removeClass('nav--open');
		this.$html.removeClass('no-scroll');

		this.$el.attr({
			'aria-expanded': 'false',
			'aria-label': 'Navigation öffnen',
		});

		this.updateAriaState();
	};

	updateAriaState = () => {
		const isDesktop = $(window).width() >= 992;

		this.$navigation.attr('aria-hidden', isDesktop ? 'false' : 'true');
		this.$overlay.attr('aria-hidden', 'true');
	};

	keydownHandler = event => {
		if (event.key === 'Escape' && this.$body.hasClass('nav--open')) {
			this.close();
		}
	};

	resizeHandler = () => {
		if ($(window).width() >= 992) {
			this.close();
		}

		this.updateAriaState();
	};
}

export default Burger;
